import React from 'react';
import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { spaces } from '@99designs/emu/settings';
import { IconButton } from '@99designs/frontend-components/components/IconButton';
import { IconX1 } from '@99designs/icons';
import { UserAvatar, UserAvatarProps } from '@99designs/users';

const Button = styled.div`
    position: absolute;
    top: ${spaces['0.5bu']};
    right: ${spaces['0.5bu']};
    transform: translate(50%, -50%);
`;

interface Props extends UserAvatarProps {
    userId: string;
    onClick?: () => void;
    onRemoveClick?: (userId: number) => void;
    badgeNumber?: number;
}

function InteractiveAvatar({ userId, onClick, onRemoveClick, badgeNumber, ...avatarProps }: Props) {
    return (
        <Box position="relative" data-testid="avatar">
            <div onClick={onClick}>
                <UserAvatar size="small" userId={userId} {...avatarProps} />
            </div>
            {onRemoveClick && (
                <Button>
                    <IconButton
                        variations={['solid']}
                        title={__('Remove designer')}
                        onClick={() => onRemoveClick(parseInt(userId))}
                    >
                        <IconX1 />
                    </IconButton>
                </Button>
            )}
            {!!badgeNumber && badgeNumber > 0 && (
                <Button>
                    <IconButton variations={['solid']} onClick={onClick}>
                        {badgeNumber}
                    </IconButton>
                </Button>
            )}
        </Box>
    );
}

export default InteractiveAvatar;
